import { GameStatus } from '@pp/core';

import { Bets } from '../../../config/bets';

export type GameResultType = {
  betSpot?: Bets;
  rc?: string;
  gameResult?: string;
  rngSlot?: string;
};

export type PlayerWinResultType = {
  winingAmount: number ;
};

export const BetSpotNames: Record<Bets, string> = {
  [Bets.One]: '1',
  [Bets.Two]: '2',
  [Bets.Five]: '5',
  [Bets.Eight]: '8',
  [Bets.Ten]: '10',
  [Bets.Fifteen]: '15',
  [Bets.Twenty]: '20',
  [Bets.Thirty]: '30',
  [Bets.Forty]: '40',
};

export enum MWSpecificGameStatus {
  'RESULT_1' = 'RESULT_1',
  'RESULT_2' = 'RESULT_2',
  'RESULT_5' = 'RESULT_5',
  'RESULT_8' = 'RESULT_8',
  'RESULT_10' = 'RESULT_10',
  'RESULT_15' = 'RESULT_15',
  'RESULT_20' = 'RESULT_20',
  'RESULT_30' = 'RESULT_30',
  'RESULT_40' = 'RESULT_40',
  'SPINNING' = 'SPINNING',
  'MEGA_MULTIPLIER' = 'MEGA_MULTIPLIER',
  'YOU_WIN' = 'YOU_WIN',
  'MEGA_WIN' = 'MEGA_WIN',
}
export const MWGameStatus = {
  ...GameStatus,
  ...MWSpecificGameStatus,
};
